
<div *ngIf="!account" role="img" class="avatar">
    <app-titan-icon aria-label="Unisex avatar icon" variant="Unisex" size="m" [displayContents]="true"/>
</div>
<div *ngIf="account" role="img" class="avatar">
{{ firstLetter }}
</div>

  

